module.exports = __webpack_public_path__ + "static/media/family.90236111.svg";